import { Button, Switch, Popconfirm, Image } from "antd";
import type { ColumnsType } from "antd/es/table";
import dayjs from 'dayjs';
import { FormConfigType } from "../../../components/editForm";
import { langPage, langCommon, langTableColumns } from "../../../locales";
import { SettingsServer } from "./../../../server";

const server = SettingsServer.Config

const lang = langPage?.settings?.config;


export const generateTableColumns = (props: any): ColumnsType => {
    const { operationRef, setLoading, refresh, loading, deleteData } = props;

    return [
        {
            title: "ID",
            dataIndex: "Id",
        },
        {
            title: "title",
            dataIndex: "Title",
        },
        {
            title: "图片地址",
            dataIndex: "Image",
            render: (_: any, row: any) => {
                return (
                    <div>
                        <Image width={100} src={row.Image} alt="" />
                    </div>
                )
            }
        },
        {
            title: "链接地址",
            dataIndex: "Link",
        },
        {
            title: "位置",
            dataIndex: "PositionString",
        },
        {
            title: "样式",
            dataIndex: "StyleString",
        },
        {
            title: "排序",
            dataIndex: "Sort",
        },
        {
            title: "状态",
            dataIndex: "StatusString",
        },
        {
            title: "创建时间",
            dataIndex: "CreatedAtString",
        },
        {
            title: langTableColumns?.operation,
            dataIndex: "ops",
            width: 100,
            fixed: "right",
            render: (_: any, row: any) => {
                return (
                    <div>
                        <Button size="small" type="link" className="pdl0"
                            onClick={() => operationRef?.current?.changeVisible({
                                ...row,
                                FundPassword: row.FundPasswordHash,
                                Password: row.PasswordHash,
                                MemberId: row.Id
                            }, 'modify')}
                        >{langCommon?.modify}</Button>
                        <Popconfirm title={langCommon?.deleteItem} onConfirm={() => deleteData?.({ Id: row.Id })} >
                            <Button size="small" type="link" loading={loading} className="pdl0 pdr0">{langCommon?.delete}</Button>
                        </Popconfirm>
                    </div>
                )
            }
        }
    ]
}
export const DEFAULT_QUERY_DATA = {
  Status: null,
  Style: null,
  Position: null,
}
export const DEFAULT_OPERATION_DATA = {
  Image: null,
  Link: null,
  Position: null,
  Sort: null,
  Status: null,
  Style: null,
  Title: null,
  Id: null
}

export const generateQueryFormConfig = (props: any): FormConfigType => {
    const { options: { positionOptions, statusOptions, styleOptions } } = props;

    return [
        {
            title: "位置",
            type: "select",
            field: "Position",
            allowClear: true,
            options: positionOptions,
        },
        {
            title: "状态",
            type: "select",
            field: "Status",
            allowClear: true,
            options: statusOptions,
        },
        {
            title: "样式",
            type: "select",
            field: "Style",
            allowClear: true,
            options: styleOptions,
        },
    ];
}

export const generateOperationFormConfig = (props: any): FormConfigType | any => {
    return [
        {
            title: "标题",
            type: "input",
            field: "Title",
            allowClear: true,
            style: { width: 200 },
            rules: [{
                required: true,
                message: `请输入标题`
            }]
        },
        {
            title: "链接",
            type: "input",
            field: "Link",
            allowClear: true,
            style: { width: 200 },
            rules: [{
                required: true,
                message: `请输入链接`
            }]
        },
        {
            title: lang?.sort,
            type: "inputNumber",
            field: "Sort",
            style: { width: 200 },
            rules: [{
                required: true,
                message: `${langCommon?.pleaseInput} ${lang?.sort}`
            }]
        },
        {
            title: "位置",
            type: "select",
            field: "Position",
            style: { width: 200 },
            options: [
                { id: 1, name: "首页" },
                { id: 2, name: "保险箱" },
                { id: 3, name: "个人中心" }
            ],
            rules: [{
                required: true,
                message: `请选择位置`
            }]
        },
        {
            title: "样式",
            type: "select",
            field: "Style",
            style: { width: 200 },
            options: [
                { id: 1, name: "白天版" },
                { id: 2, name: "黑夜版" },
            ],
            rules: [{
                required: true,
                message: `请选择样式`
            }]
        },
        {
            title: langCommon?.status,
            type: "select",
            field: "Status",
            style: { width: 200 },
            options: [
                { id: 1, name: langCommon?.enabled },
                { id: 2, name: langCommon?.disable }
            ],
            rules: [{
                required: true,
                message: `${langCommon?.pleaseInput} ${langCommon?.status}`
            }]
        },
    ];
}